var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-col',{attrs:{"span":_vm.span}},[_c('el-form-item',{attrs:{"label":_vm.label,"label-width":_vm.labelWidth,"prop":_vm.prop,"required":_vm.required}},[_vm._t("default",function(){return [_c('span',{attrs:{"title":_vm.content}},[_vm._v(_vm._s(_vm.content||"--"))])]})],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-480dd9dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/childcomponents/EleFormItem/index.vue
// module id = null
// module chunks = 